import React from "react";
import { MoonStar, Hourglass, Sunrise, Timer, Repeat } from "lucide-react";
import { METODO } from "@/content";
import WhatsAppButton from "@/components/WhatsAppButton";
import Reveal from "@/components/Reveal";

const ICONS = { MoonStar, Hourglass, Sunrise };

export default function Metodo() {
  return (
    <section
      className="py-16 md:py-24"
      style={{ background: "var(--blanco)" }}
      data-testid="section-metodo"
    >
      <div className="container-page">
        <Reveal className="text-center">
          <span className="chip">
            <Timer size={15} strokeWidth={2} aria-hidden="true" />
            {METODO.badge}
          </span>
          <h2 className="h2-display mt-5" style={{ color: "var(--vino)" }}>
            El Método de las{" "}
            <span style={{ color: "var(--lima)" }}>5 Noches</span>
          </h2>
        </Reveal>

        <div className="relative mt-12">
          {/* línea punteada conectora */}
          <div
            className="hidden md:block absolute"
            style={{
              top: 44,
              left: "16%",
              right: "16%",
              height: 0,
              borderTop: "2px dashed var(--lima)",
              opacity: 0.6,
            }}
            aria-hidden="true"
          />
          <div
            className="md:hidden absolute"
            style={{
              left: 27,
              top: 40,
              bottom: 40,
              width: 0,
              borderLeft: "2px dashed var(--lima)",
              opacity: 0.6,
            }}
            aria-hidden="true"
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative">
            {METODO.pasos.map((p, i) => {
              const Icon = ICONS[p.icon] || MoonStar;
              return (
                <Reveal
                  key={p.num}
                  delay={i * 80}
                  className="flex md:flex-col md:items-center gap-4 md:gap-0 md:text-center"
                >
                  <div className="shrink-0 relative">
                    <span
                      className="flex items-center justify-center rounded-full"
                      style={{
                        width: 56,
                        height: 56,
                        background: "var(--lima-soft)",
                        border: "3px solid var(--blanco)",
                        boxShadow: "var(--shadow-soft)",
                      }}
                    >
                      <Icon size={26} strokeWidth={2} style={{ color: "var(--vino)" }} />
                    </span>
                  </div>
                  <div className="md:mt-5">
                    <span
                      className="font-display block"
                      style={{ fontSize: 13, color: "var(--lima)", letterSpacing: "0.1em" }}
                    >
                      {p.num}
                    </span>
                    <h3
                      className="font-display mt-1"
                      style={{ fontSize: 22, color: "var(--vino)" }}
                    >
                      {p.titulo}
                    </h3>
                    <p
                      className="mt-2 text-[16px] leading-snug md:max-w-[26ch] md:mx-auto"
                      style={{ color: "var(--gris)" }}
                    >
                      {p.text}
                    </p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <Reveal delay={120} className="mt-12 flex justify-center">
          <div
            className="flex items-center gap-3 px-6 py-5 max-w-[560px] w-full"
            style={{
              background: "var(--lima-soft)",
              border: "2px solid var(--lima)",
              borderRadius: 24,
            }}
          >
            <Repeat
              size={22}
              strokeWidth={2}
              style={{ color: "var(--vino)", flexShrink: 0 }}
              aria-hidden="true"
            />
            <p
              className="font-display"
              style={{ fontSize: 17, color: "var(--vino)", lineHeight: 1.3 }}
            >
              {METODO.destacada}
            </p>
          </div>
        </Reveal>

        <Reveal delay={200} className="mt-8 flex justify-center">
          <WhatsAppButton section="metodo" full className="sm:w-auto" />
        </Reveal>
      </div>
    </section>
  );
}
